import React, {Fragment, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {ProductVisibleVoucher} from "./ProductVisibleVoucher";

export function PurchaseVoucher({type}: { type: string }) {
  // 임시 처리
  const navigate = useNavigate();
  const isThisPageNotShowable = process.env.REACT_APP_MODE === "운영" && type === "counselor";


  useEffect(() => {
    if (isThisPageNotShowable) { // 운영 모드가 아니고 타입이 상담사인 경우
      alert("상담 서비스는 현재 점검중입니다.\n2025년 상반기 서비스가 제공될 예정입니다.\n감사합니다.")
      navigate('/')
    }
    // eslint-disable-next-line
  }, []);

  const GoToHome = () => {
    return <></>
  }

  return (
      <>
        {isThisPageNotShowable
            ? <GoToHome />
            : <ProductVisibleVoucher type={type} />
        }
      </>
  )

}
